// Auto-generated user-center i18n extras. Do not edit by hand unless necessary.
export default {
  "ucAccount": {
    "personal": {
      "section": {
        "basicInfo": "基础信息",
        "professionalInfo": "职业信息"
      },
      "identityType": {
        "mainland": "大陆身份",
        "hkmt": "港澳台身份"
      },
      "form": {
        "idCardType": "证件类型",
        "uploadIdCard": "上传身份证",
        "uploadCertificate": "上传证件",
        "realName": "真实姓名",
        "idCardNo": "身份证号码",
        "certificateNo": "证件号码",
        "internationalName": "国际用名",
        "phone": "手机号码",
        "email": "电子邮件",
        "industryType": "行业类型",
        "unitName": "单位名称",
        "jobPosition": "任职岗位",
        "region": "所在地区"
      },
      "idCard": {
        "mainland": "大陆身份证",
        "hkId": "香港居民身份证",
        "hkMacaoPass": "港澳居民往来内地通行证",
        "taiwanPass": "台湾居民来往大陆通行证"
      },
      "upload": {
        "frontAlt": "身份证正面",
        "backAlt": "身份证反面",
        "frontLabel": "点击上传正面（单个文件大小 不超过2MB）",
        "backLabel": "点击上传反面（单个文件大小 不超过2MB）"
      },
      "placeholder": {
        "autoRecognize": "根据上传自动识别",
        "internationalName": "非必选项，有国际备案需求的用户建议填写",
        "pleaseInput": "请输入",
        "pleaseSelect": "请选择",
        "regionCascader": "请选择省/市/区"
      },
      "btn": {
        "reAuth": "重新认证",
        "submit": "提交认证"
      },
      "rule": {
        "selectIdCardType": "请选择证件类型",
        "uploadFront": "请上传证件正面",
        "uploadBack": "请上传证件反面",
        "inputRealName": "请输入真实姓名",
        "inputIdCardNo": "请输入证件号码",
        "inputPhone": "请输入手机号码",
        "phoneInvalid": "请输入正确的手机号码",
        "inputEmail": "请输入电子邮件",
        "emailInvalid": "请输入正确的电子邮件地址",
        "selectRegion": "请选择所在地区",
        "selectIndustry": "请选择行业类型"
      },
      "validate": {
        "mainlandId": "请输入正确的大陆身份证号码（15位或18位）",
        "hkMacaoPass": "请输入正确的港澳居民往来内地通行证号码（H/M开头+8位或10位数字）",
        "taiwanPass": "请输入正确的台湾居民来往大陆通行证号码（8位数字）",
        "hkId": "请输入正确的香港居民身份证号码（如 A123456(0) 或 C668668(E)）"
      },
      "msg": {
        "formIncomplete": "请检查并完善表单信息",
        "submitting": "提交中...",
        "submitSuccess": "身份认证提交成功"
      }
    },
    "enterprise": {
      "section": {
        "basicInfo": "基础信息"
      },
      "regionType": {
        "mainland": "大陆身份",
        "hkmt": "港澳台身份"
      },
      "type": {
        "enterprise": "企业",
        "association": "社会组织"
      },
      "form": {
        "authType": "认证类型",
        "businessLicense": "营业执照",
        "registrationCert": "登记证书",
        "enterpriseName": "企业名称",
        "orgName": "机构名称",
        "internationalName": "国际名称",
        "creditCode": "统一社会信用代码",
        "registrationLicenseNo": "登记执照号",
        "orgCertNo": "机构证书号",
        "orgType": "机构类型",
        "industryType": "行业类型",
        "region": "所在地区",
        "contactPerson": "联系人",
        "email": "电子邮件",
        "phone": "手机号码",
        "smsCode": "验证码"
      },
      "upload": {
        "brc": "点击上传商业登记证BRC（单个文件大小不超过2MB）",
        "enterpriseLicense": "点击上传企业营业执照（单个文件大小不超过2MB）",
        "associationCert": "点击上传社会组织登记证书（单个文件大小不超过2MB）",
        "prefix": "点击上传",
        "suffix": "（单个文件大小不超过2MB）",
        "fileEnterpriseLicense": "企业营业执照",
        "fileAssociationCert": "社会组织登记证书"
      },
      "placeholder": {
        "pleaseInputPrefix": "请输入",
        "internationalName": "非必选项，有国际备案需求的企业建议填写",
        "selectOrgType": "请选择机构类型",
        "selectIndustry": "请选择行业类型",
        "selectRegion": "请选择所在地区",
        "contactPerson": "请输入联系人",
        "email": "请输入电子邮件",
        "phone": "请输入手机号码",
        "smsCode": "请输入验证码"
      },
      "btn": {
        "getCode": "获取验证码",
        "countdown": "{n}秒后重新获取",
        "reAuth": "重新认证",
        "submit": "提交认证",
        "rejectedResubmit": "未通过，重新认证"
      },
      "rule": {
        "uploadLicense": "请上传{label}",
        "inputName": "请输入{label}",
        "inputCreditCode": "请输入{label}",
        "creditCodeInvalid": "请输入正确的{label}",
        "inputContact": "请输入联系人",
        "inputPhone": "请输入手机号码",
        "phoneInvalid": "请输入正确的手机号码",
        "inputSmsCode": "请输入验证码",
        "inputEmail": "请输入电子邮件",
        "emailInvalid": "请输入正确的电子邮件格式",
        "selectRegion": "请选择所在地区",
        "selectIndustry": "请选择行业类型",
        "selectOrgType": "请选择机构类型"
      },
      "msg": {
        "phoneRequired": "请先输入手机号码",
        "phoneInvalid": "请输入正确的手机号码",
        "codeSent": "验证码已发送",
        "selectRegionType": "请选择地区类型",
        "uploadLicense": "请上传营业执照",
        "submitting": "提交中...",
        "submitSuccess": "企业身份认证提交成功",
        "reAuthSuccess": "企业重新认证提交成功"
      }
    },
    "resetPassword": {
      "title": "重置密码",
      "form": {
        "contactPhone": "企业联系人手机号",
        "smsCode": "验证码",
        "newPassword": "新密码",
        "confirmPassword": "确认密码"
      },
      "placeholder": {
        "loadingPhone": "正在获取企业联系人手机号",
        "smsCode": "请输入验证码",
        "newPassword": "8-20位，须含大小写字母和数字",
        "confirmPassword": "请再次输入新密码"
      },
      "btn": {
        "getCode": "获取验证码",
        "countdown": "{n}秒后重新获取",
        "submit": "提交修改"
      },
      "rule": {
        "phoneMissing": "未获取到企业联系人手机号",
        "inputSmsCode": "请输入验证码",
        "smsCodeLen": "验证码为6位数字",
        "inputNewPassword": "请输入新密码",
        "confirmAgain": "请再次输入密码",
        "passwordMismatch": "两次输入密码不一致"
      },
      "msg": {
        "phoneMissingWarn": "未获取到企业联系人手机号",
        "phoneMissingError": "未获取到企业联系人手机号",
        "phoneInvalid": "请输入正确的手机号码",
        "codeSent": "验证码已发送",
        "resetSuccess": "密码重置成功"
      }
    },
    "memberEdit": {
      "title": "协会会员信息编辑",
      "form": {
        "unitAvatar": "单位标志",
        "entName": "单位名称",
        "nature": "企业性质",
        "industryType": "行业类别",
        "mainProducts": "主营产品",
        "introduce": "单位介绍",
        "mainProductsList": "主要产品"
      },
      "upload": {
        "alt": "单位标志",
        "label": "尺寸比例16:9，建议尺寸384*216px，文件大小不超过10M"
      },
      "placeholder": {
        "entName": "请输入单位名称",
        "nature": "请输入企业性质",
        "industryType": "请输入行业类别",
        "mainProducts": "请输入主营产品",
        "introduce": "请输入单位介绍",
        "mainProductItem": "请输入主要产品"
      },
      "btn": {
        "add": "添加",
        "confirm": "确认修改"
      },
      "rule": {
        "uploadAvatar": "请上传单位标志",
        "inputEntName": "请输入单位名称",
        "inputNature": "请输入企业性质",
        "inputIndustry": "请输入行业类别",
        "inputMainProducts": "请输入主营产品",
        "inputIntroduce": "请输入单位介绍",
        "minMainProducts": "请至少添加一个主要产品"
      },
      "msg": {
        "noComma": "主要产品不能包含逗号",
        "duplicateProduct": "已存在相同产品",
        "loadFail": "获取信息失败",
        "submitSuccess": "已提交修改申请，请等待协会管理人员确认",
        "submitFail": "修改失败"
      },
      "confirm": {
        "message": "确认提交修改吗？提交后会自动从协会会员单位中下架，协会管理人员确认后展示。",
        "title": "提示",
        "ok": "确认提交",
        "cancel": "取消"
      }
    },
    "enterpriseAdmin": {
      "btn": {
        "replaceSuperAdmin": "更换超级管理员"
      },
      "dialog": {
        "replaceTitle": "更换超级管理员",
        "confirmReplace": "确认更换"
      },
      "status": {
        "enable": "启用",
        "disable": "禁用",
        "unknown": "未知"
      },
      "confirm": {
        "toggleStatus": "确定要{statusText}管理员\"{name}\"吗？",
        "title": "提示",
        "ok": "确定",
        "cancel": "取消"
      },
      "msg": {
        "inviteSuccess": "发送邀请成功",
        "replaceSuccess": "更换超级管理员成功"
      }
    }
  },
  "ucJoinChannel": {
    "title": "加入渠道",
    "form": {
      "channelCode": "渠道码"
    },
    "placeholder": {
      "channelCode": "请输入渠道码，享受数字备案优惠"
    },
    "btn": {
      "join": "加入渠道"
    },
    "fallback": {
      "unnamedChannel": "未命名渠道"
    },
    "msg": {
      "selectChannel": "请选择渠道",
      "inputChannelCode": "请输入渠道码",
      "joinSuccess": "加入渠道成功"
    }
  },
  "ucOrder": {
    "filter": {
      "all": "全部",
      "orderTime": "订单时间"
    },
    "date": {
      "rangeSeparator": "至",
      "startPlaceholder": "开始日期",
      "endPlaceholder": "结束日期"
    },
    "btn": {
      "myInvoice": "我的发票",
      "detail": "详情"
    },
    "table": {
      "orderNo": "订单编号",
      "orderType": "订单类型",
      "orderAmount": "订单金额",
      "payableAmount": "实际支付金额",
      "orderTime": "下单时间",
      "payMethod": "付款方式",
      "payTime": "付款时间",
      "payStatus": "支付状态",
      "operation": "操作"
    },
    "detail": {
      "title": "订单详情",
      "orderNo": "订单编号",
      "orderType": "订单类型",
      "orderAmount": "订单金额",
      "payableAmount": "实际支付金额",
      "payStatus": "支付状态",
      "payMethod": "付款方式",
      "orderTime": "下单时间",
      "payTime": "付款时间",
      "goodsType": "商品类型",
      "goodsName": "商品名称",
      "refundAmount": "退款金额",
      "remark": "备注"
    },
    "payMethod": {
      "zero": "零元支付",
      "alipay": "支付宝",
      "wechat": "微信支付"
    },
    "payStatus": {
      "pending": "待支付",
      "success": "支付成功",
      "cancelled": "已取消",
      "refunded": "已退款"
    }
  },
  "ucInvoice": {
    "filter": {
      "all": "全部",
      "invoiceStatus": "发票状态",
      "orderNo": "订单号"
    },
    "placeholder": {
      "statusAll": "全部",
      "orderNo": "请输入订单号"
    },
    "status": {
      "all": "全部",
      "invoiced": "已开票",
      "pending": "待开票"
    },
    "btn": {
      "confirmInvoice": "确认开票",
      "confirmInvoiceWithCount": "确认开票（{n}）",
      "detail": "详情",
      "invoice": "开票"
    },
    "table": {
      "orderNo": "订单编号",
      "orderType": "订单类型",
      "orderTime": "下单时间",
      "productName": "商品名称",
      "orderAmount": "订单金额(元)",
      "payAmount": "支付金额(元)",
      "payTime": "付款时间",
      "invoiceStatus": "发票状态",
      "operation": "操作"
    },
    "detail": {
      "title": "订单详情",
      "orderNo": "订单编号",
      "orderType": "订单类型",
      "invoiceStatus": "发票状态",
      "orderAmount": "订单金额(元)",
      "payAmount": "支付金额(元)",
      "productName": "商品名称",
      "orderTime": "下单时间",
      "payTime": "付款时间",
      "remark": "备注"
    },
    "msg": {
      "selectPending": "请选择待开票订单"
    },
    "issue": {
      "title": "开发票",
      "section": {
        "headerInfo": "发票抬头信息"
      },
      "btn": {
        "addHeader": "新增发票抬头",
        "setDefault": "设置默认",
        "delete": "删除",
        "confirmInvoice": "确认开票",
        "confirm": "确认"
      },
      "empty": {
        "noHeader": "暂无发票抬头，请先新增"
      },
      "badge": {
        "defaultHeader": "默认抬头"
      },
      "label": {
        "titleType": "抬头类型：",
        "taxNumber": "税号：",
        "companyAddress": "单位地址：",
        "phone": "电话：",
        "bankName": "开户银行：",
        "bankAccount": "银行账户：",
        "enterpriseTitle": "企业抬头",
        "personalTitle": "个人抬头",
        "receiveEmail": "接收邮箱",
        "email": "邮箱"
      },
      "stats": {
        "selectedOrders": "已选订单：",
        "orderUnit": "笔",
        "orderNo": "订单编号：",
        "amount": "开票金额：",
        "yuan": "元"
      },
      "headerDialog": {
        "addTitle": "新增发票抬头",
        "editTitle": "编辑发票抬头"
      },
      "headerForm": {
        "titleType": "抬头类型",
        "taxNumber": "税号",
        "companyAddress": "单位地址",
        "phone": "电话",
        "bankName": "开户银行",
        "bankAccount": "银行账户"
      },
      "placeholder": {
        "pleaseInput": "请输入"
      },
      "rule": {
        "selectTitleType": "请选择抬头类型",
        "inputEnterpriseTitle": "请输入企业抬头",
        "inputPersonalTitle": "请输入个人抬头",
        "inputReceiveEmail": "请输入接收邮箱",
        "inputEmail": "请输入邮箱",
        "emailInvalid": "请输入正确的邮箱格式",
        "inputTaxNumber": "请输入税号",
        "inputCompanyAddress": "请输入单位地址",
        "inputPhone": "请输入电话",
        "inputBankName": "请输入开户银行",
        "inputBankAccount": "请输入银行账户"
      },
      "msg": {
        "selectOrAddHeader": "请选择或新增发票抬头",
        "selectOrders": "请选择需要开票的订单",
        "invalidOrderNo": "订单编号无效",
        "invoiceSuccess": "你的开票申请已提交，请注意在邮箱查收。",
        "batchInvoiceSuccess": "你的开票申请已提交，请注意在邮箱查收。",
        "invoiceFail": "开票失败",
        "setDefaultSuccess": "已设为默认发票抬头",
        "deleteSuccess": "删除成功",
        "loginRequired": "请先登录",
        "editSuccess": "编辑成功",
        "addSuccess": "新增成功"
      },
      "confirm": {
        "deleteHeader": "确定删除该发票抬头吗？",
        "title": "提示",
        "ok": "确定"
      },
      "titleTypeOption": {
        "personal": "个人",
        "enterprise": "企业"
      }
    },
    "billDetail": {
      "title": "发票详情",
      "status": {
        "current": "当前开票状态",
        "unknown": "未知状态"
      },
      "btn": {
        "previewInvoice": "预览发票",
        "preview": "预览",
        "copyLink": "复制链接"
      },
      "section": {
        "buyer": "购方信息",
        "invoice": "发票信息"
      },
      "buyer": {
        "name": "购方名称",
        "taxNo": "购方税号",
        "phone": "交付电话",
        "address": "购方地址",
        "bankName": "开户银行",
        "bankAccount": "银行账号"
      },
      "invoice": {
        "type": "发票种类",
        "redBlueFlag": "红蓝标志",
        "drawer": "开票人",
        "codeNo": "代码/号码",
        "digitNo": "数电发票号码",
        "digitAccount": "数电账号",
        "createDate": "创建日期",
        "invoiceDate": "开票日期",
        "issueMethod": "开票方式",
        "issueMethodValue": "接口开具"
      },
      "flag": {
        "blue": "蓝票",
        "red": "红票"
      },
      "typeCode": {
        "85": "数电纸质发票(增值税专用发票)",
        "86": "数电纸质发票(普通发票)",
        "87": "数电纸质发票(机动车销售统一发票)",
        "88": "数电纸质发票(二手车销售统一发票)",
        "01": "数电票(增值税专用发票)",
        "02": "数电票(普通发票)",
        "004": "增值税专用发票",
        "005": "机动车销售统一发票",
        "006": "二手车销售统一发票",
        "007": "增值税普通发票",
        "025": "增值税普通发票(卷式)",
        "026": "增值税电子普通发票",
        "028": "增值税电子专用发票"
      },
      "pdf": {
        "name": "电子发票 PDF 源文件",
        "hint": "可直接在线预览或复制链接下载"
      },
      "empty": {
        "noBill": "暂无票据信息"
      },
      "msg": {
        "noPdfUrl": "暂无 PDF 地址",
        "copied": "已添加到剪贴板",
        "copyFail": "复制失败，请手动复制",
        "invalidOrderNo": "订单编号无效",
        "noBillWarn": "暂无票据信息",
        "queryFail": "查询票据失败"
      }
    }
  },
  "ucMessage": {
    "actions": {
      "markAllRead": "一键标记已读"
    },
    "loading": "加载中...",
    "status": {
      "unread": "未读",
      "read": "已读",
      "starred": "已加星标"
    },
    "confirm": {
      "markAllRead": "确定要将所有\"{messageTypeName}\"类型的未读消息标记为已读吗？",
      "title": "确认操作",
      "ok": "确定",
      "cancel": "取消"
    },
    "fallback": {
      "systemMessage": "系统消息"
    },
    "toast": {
      "markSuccess": "标记成功"
    },
    "tabs": {
      "system": "系统消息",
      "business": "业务消息",
      "activity": "活动消息"
    }
  },
  "ucApproval": {
    "tabs": {
      "pending": "待我授权",
      "myInitiated": "我的发起"
    },
    "columns": {
      "applicant": "发起主体用户",
      "approver": "接受主体用户",
      "businessType": "业务类型",
      "status": "状态",
      "createTime": "发起时间",
      "operateTime": "操作时间",
      "actions": "操作"
    },
    "actions": {
      "authorize": "授权",
      "detail": "详情"
    },
    "mobile": {
      "applicant": "发起主体：",
      "approver": "接受主体：",
      "createTime": "发起时间：",
      "operateTime": "操作时间："
    },
    "status": {
      "unknown": "未知",
      "pending": "待授权",
      "approved": "已通过",
      "rejected": "已驳回"
    },
    "toast": {
      "loadMyInitiatedFail": "加载我的发起列表失败",
      "approved": "授权通过"
    },
    "detail": {
      "title": "授权详情",
      "ok": "确定",
      "applicant": "发起主体用户：",
      "approver": "接受主体用户：",
      "businessType": "业务类型：",
      "status": "状态：",
      "createTime": "发起时间：",
      "operateTime": "操作时间："
    },
    "confirm": {
      "message": "确定要授权该申请吗？",
      "title": "授权确认",
      "pass": "通过",
      "reject": "拒绝",
      "applicant": "发起主体用户：",
      "businessType": "业务类型："
    }
  },
  "ucConsultation": {
    "tabs": {
      "awaitingAnswer": "咨询待解答",
      "inConsultation": "咨询中",
      "completed": "咨询结束"
    },
    "search": {
      "placeholder": "请输入"
    },
    "columns": {
      "index": "序号",
      "title": "标题",
      "type": "咨询事务类型",
      "industry": "咨询行业",
      "area": "涉及地区",
      "submitTime": "提交时间",
      "actions": "操作"
    },
    "actions": {
      "detail": "详情"
    },
    "toast": {
      "loadDetailFail": "加载咨询详情失败"
    },
    "detail": {
      "back": "返回",
      "labels": {
        "title": "标题：",
        "type": "咨询事务类型：",
        "industry": "咨询行业：",
        "area": "涉及区域：",
        "content": "内容：",
        "attachment": "附件：",
        "expert": "分配专家："
      },
      "attachmentFallback": "附件",
      "preview": "预览",
      "download": "下载",
      "alt": {
        "customer": "客户",
        "replier": "回复方"
      },
      "chatEmpty": "暂无聊天记录",
      "placeholder": {
        "reply": "请输入回复内容",
        "followUp": "请输入要追加的咨询内容"
      },
      "finish": "结束咨询",
      "replyBtn": {
        "sendReply": "发送回复",
        "append": "追加咨询"
      },
      "endedTip": "咨询已结束",
      "toast": {
        "needContent": "请输入内容",
        "abnormal": "咨询信息异常",
        "sendSuccess": "发送成功",
        "sendFail": "发送失败",
        "finished": "已结束咨询",
        "operateFail": "操作失败"
      },
      "confirm": {
        "finish": "确定结束本次咨询？结束后将无法继续发送消息。",
        "tip": "提示"
      }
    }
  },
  "ucActivity": {
    "title": "我参与的活动",
    "search": {
      "placeholder": "请输入查询内容"
    },
    "date": {
      "rangeSeparator": "至",
      "startPlaceholder": "开始月份",
      "endPlaceholder": "结束月份",
      "format": "YYYY年M月"
    },
    "actions": {
      "query": "查询",
      "reset": "重置",
      "viewDetail": "查看详情"
    },
    "card": {
      "activityId": "活动ID:"
    },
    "empty": "暂无参与的活动",
    "loading": "加载中..."
  },
  "ucCollection": {
    "tabs": {
      "ip": "收藏IP",
      "supplyChain": "收藏供应链"
    },
    "actions": {
      "goTradingCenter": "前往授权交易中心"
    },
    "empty": {
      "supplyChain": "暂无收藏的供应链",
      "ip": "暂无收藏的IP"
    }
  }
}
